import { render, staticRenderFns } from "./ClassificationQuestion.vue?vue&type=template&id=51094c52&scoped=true"
import script from "./ClassificationQuestion.vue?vue&type=script&lang=js"
export * from "./ClassificationQuestion.vue?vue&type=script&lang=js"
import style0 from "./evaluationTheme.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./ClassificationQuestion.vue?vue&type=style&index=1&id=51094c52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51094c52",
  null
  
)

export default component.exports